<template>
  <v-main>
    <v-alert id="alert" v-model="alert.isAlert" :type="alert.type" closable class="row">{{ alert.message }}</v-alert>
    <v-overlay :model-value="showOverlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container>
      <h1>請求書送付先</h1>
    </v-container>
    <v-container v-for="(billing, key) in billingList" :key="key">
      <v-card name="billing">
        <v-card-title>
          <v-row>
            <v-col cols="12" sm="6" md="1">
              <v-text-field name="billingId" :model-value="billing.billing_id" label="契約ID" readonly density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field name="billingName" :model-value="billing.billing_name" label="法人名" readonly density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field name="billingSectionName" :model-value="billing.billing_section_name" label="部署" readonly density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                name="billingRepresentativeName"
                :model-value="billing.billing_representative_name"
                label="担当者"
                readonly
                density="compact"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>
        <v-data-table :headers="headers" :items="billing.billing_destination_address" :hide-default-footer="true" class="elevation-1 contact-table" dense>
          <template #[`item.actions`]="props">
            <template v-if="isEditable() && props.item.editable">
              <v-icon color="success" size="small" @click="edit(billing, key, props.item.address)"> mdi-pencil </v-icon>
            </template>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <template>
      <v-form ref="form" lazy-validation>
        <v-dialog v-model="dialog" persistent max-width="80%">
          <v-card>
            <v-card-title>請求書送付先住所</v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-textarea v-model="editedItem.currentAddress" label="変更前" disabled auto-grow></v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea v-model="editedItem.newAddress" :rules="[rules.required]" label="変更後"></v-textarea>
                  </v-col>
                  <v-checkbox v-model="editedItem.isCopyAllBillings" label="すべての契約にコピーする"></v-checkbox>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue-darken-1" variant="text" @click="close()"> キャンセル </v-btn>
              <v-btn color="blue-darken-1" variant="text" @click="save()"> 更新 </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-form>
    </template>
  </v-main>
</template>

<script>
import Api from '@/constants/api';
import UserRole from '@/constants/userrole';

export default {
  props: {
    xxxalert: {
      type: Object,
      default: function () {
        return {
          isAlert: false,
          type: 'success',
          message: '',
        };
      },
    },
  },
  data: () => ({
    headers: [
      { text: '', value: 'month', sortable: false, filterable: false, width: '10%' },
      { text: '請求書送付先住所', value: 'address', sortable: false, filterable: false, width: '85%' },
      { text: '', value: 'actions', sortable: false, filterable: false, width: '5%' },
    ],
    billingList: [],
    showOverlay: false,
    dialog: false,
    rules: {
      required: (value) => !!value || '必須項目です',
    },
    editedItem: {
      key: '',
      billingId: '',
      currentAddress: '',
      newAddress: '',
      isCopyAllBillings: false,
    },
    loginUser: {
      billinggroupId: '',
      roleId: -1,
    },
    alert: { isAlert: false, type: 'success', message: '' },
  }),
  created: async function () {
    this.showOverlay = true;
    try {
      await this.createBillingList();
    } finally {
      this.showOverlay = false;
    }
  },
  methods: {
    createBillingList: async function () {
      const accessToken = this.$cookies.get('access_token');
      console.log('accessToken=' + accessToken);

      let sessionResponse = await this.axios.get(Api.PATH_SESSION);
      console.log(sessionResponse);
      if (sessionResponse.data.status == Api.STATUS_SUCCESS) {
        this.loginUser.billinggroupId = sessionResponse.data.session.billinggroup_id;
        this.loginUser.roleId = sessionResponse.data.session.role_id;
      } else {
        this.$cookies.remove('access_token');
        this.$router.push({ name: 'Login' });
        return;
      }

      if (!this.loginUser.billinggroupId) {
        console.log('billinggroupId is invalid.');
        return;
      }

      let billingResponse = await this.axios.get(Api.PATH_BILLING, {
        params: {
          billinggroup_id: this.loginUser.billinggroupId,
        },
      });
      console.log(billingResponse);
      if (billingResponse.data.status == Api.STATUS_SUCCESS) {
        this.billingList = billingResponse.data.billing_list;
        console.log(this.billingList);
      } else {
        throw 'API_BILLINGS failed. status=' + billingResponse.data.status;
      }

      if (!this.billingList) {
        console.log('billingList is invalid.');
        return;
      }

      // 表示用の内容へ変更
      for (let i = 0; i < this.billingList.length; i++) {
        let billingDestinationAddressLastmonth;
        let billingDestinationAddressThismonth;
        if (this.billingList[i].billing_destination_address_lastmonth) {
          billingDestinationAddressLastmonth = this.billingList[i].billing_destination_address_lastmonth;
        } else {
          billingDestinationAddressLastmonth = '';
        }
        if (this.billingList[i].billing_destination_address_thismonth) {
          billingDestinationAddressThismonth = this.billingList[i].billing_destination_address_thismonth;
        } else {
          billingDestinationAddressThismonth = '';
        }
        let lastMonth = new Date().getMonth();
        if (lastMonth == 0) {
          lastMonth = 12;
        }
        let thisMonth = new Date().getMonth() + 1;
        this.billingList[i].billing_destination_address = [
          {
            month: lastMonth + '月分',
            address: billingDestinationAddressLastmonth,
            editable: false,
          },
          {
            month: thisMonth + '月分',
            address: billingDestinationAddressThismonth,
            editable: true,
          },
        ];
      }
    },
    showAlert: function (type, message) {
      this.alert.isAlert = true;
      this.alert.type = type;
      this.alert.message = message;
    },
    edit: function (billing, key, address) {
      this.$refs.form.resetValidation();
      this.editedItem.key = key;
      this.editedItem.billingId = billing.billing_id;
      this.editedItem.currentAddress = address;
      this.editedItem.newAddress = address;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.editedItem.isCopyAllBillings = false;
    },
    save: async function () {
      if (!this.isEditable()) {
        throw 'API_ACCOUNT_CREATE_USER unauthorized.';
      }
      if (!this.$refs.form.validate()) {
        console.log('validate error.');
        return;
      }
      let message;
      if (this.editedItem.isCopyAllBillings) {
        if (confirm('全ての契約の請求書送付先情報を変更してもよろしいですか？')) {
          for (let i = 0; i < this.billingList.length; i++) {
            this.updateBillingDestinationAddress(i, this.editedItem.newAddress);
          }
          message = '全ての契約の請求書送付先情報を変更しました。';
        }
      } else {
        this.updateBillingDestinationAddress(this.editedItem.key, this.editedItem.newAddress);
        message = this.editedItem.billingId + 'の請求書送付先情報を変更しました。';
      }
      this.close();
      this.showAlert('success', message);
      window.scrollTo({ top: 0 });
    },
    async updateBillingDestinationAddress(index, newAddress) {
      const accessToken = this.$cookies.get('access_token');
      const billingId = this.billingList[index].billing_id;
      let billingResponse = await this.axios.post(Api.PATH_BILLING_UPDATE, {
        access_token: accessToken,
        billing_id: billingId,
        billing_destination_address: newAddress,
      });
      console.log(billingResponse);
      if (billingResponse.data.status == Api.STATUS_SUCCESS) {
        this.billingList[index].billing_destination_address[1].address = newAddress;
      } else {
        throw 'API_BILLINGS failed. status=' + billingResponse.data.status;
      }
    },
    isEditable: function () {
      switch (this.loginUser.roleId) {
        case UserRole.ADMIN:
        case UserRole.MANAGER:
          return true;
        default:
          return false;
      }
    },
  },
};
</script>
<style>
.contact-table td {
  white-space: pre-wrap;
}
.v-overlay {
  align-items: center;
  justify-content: center;
}
</style>
